<template>
  <v-app id="layout">
    <v-navigation-drawer
      v-if="isNotLoginPage()"
      v-model="drawer"
      app
      clipped
      color="red"
      dark
    >
      <v-list class="menu">
        <v-list-item
          class="menu-item"
          v-for="(page, i) in menu"
          :key="i"
          :to="page.route"
          link
        >
          <v-list-item-content>
            <v-list-item-title>{{ page.label }}</v-list-item-title>
            <v-list-item-title class="sublabel" v-if="page.sublabel"
              >- {{ page.sublabel }}</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-btn
        color="#1e1e3c"
        class="logout-btn"
        style="background-color:#776ff3 !important;"
        rounded
        @click="logout()"
      >
        <span class="material-icons">exit_to_app</span>
        Logout
      </v-btn>
    </v-navigation-drawer>

    <v-app-bar v-if="isNotLoginPage()" app clipped-left color="#932259" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <img
        class="logo"
        src="https://www.netsonda.pt/wp-content/uploads/2019/12/logo-v2.png"
        style="width: 170px !important;"
      />
    </v-app-bar>

    <v-content>
      <div class="main-content">
        <router-view></router-view>
      </div>
    </v-content>

    <v-footer app v-if="isNotLoginPage()">
      <span>&copy; 2023</span>
    </v-footer>
  </v-app>
</template>

<script>
  // import { mapGetters } from 'vuex'

  export default {
    name: "App",
    props: {
      source: String,
    },
    data: () => ({
      items: ["Foo", "Bar", "Fizz", "Buzz"],
      drawer: null,
      menu: [{ label: "Formulário", route: "/" }],
      backdoor: 0,
    }),
    computed: {
      login() {
        this.backdoor;
        let logged = window.sessionStorage.getItem("loggedIn") || false;
        return logged == "true";
      },
    },
    created() {
      this.$vuetify.theme.light = true;
    },
    mounted() {
      this.prepareApp();
    },
    methods: {
      async prepareApp() {
        await this.$store.dispatch("validateState");
        this.backdoor += 1;
        this.$forceUpdate();

        if (this.login == false && this.$router.currentRoute.path != "/login") {
          this.$router.push("/login");
        }
      },
      async logout() {
        window.sessionStorage.clear();

        this.$router.push("/login");
      },
      isNotLoginPage: function() {
        return this.$router.currentRoute.path != "/login";
      },
    },
    watch: {
      $route(to) {
        this.prepareApp();
        document.title = to.meta.title || "NetSonda";
      },
    },
  };
</script>

<style lang="scss">
  ::-webkit-scrollbar {
    display: none;
  }
  html {
    -ms-overflow-style: none;
  }
  .v-list-item {
    min-height: auto !important;
  }
  #layout {
    background-color: #e8e7e3 !important;
    font-family: "Montserrat", sans-serif;
    .menu {
      padding-top: 25px;
      .menu-item {
        padding-left: 40px;
        font-weight: 400;
        text-transform: uppercase;
        margin: 10px 0;
        letter-spacing: 0px;
        font-family: "Kodchasan", sans-serif;
      }
    }
    .logo {
      width: 200px;
      padding-left: 25px;
    }

    .user-btn {
      position: absolute;
      right: 40px;
      top: 30px;
    }
    .title-form {
      font-size: 20px !important;
      font-family: "Montserrat", sans-serif;
      font-weight: 500;
    }
    .main-content {
      padding: 80px 30px;
      .table-container {
        padding: 30px;
      }
      .section-title {
        font-family: "Kodchasan", sans-serif;
        font-weight: 600;
        color: #fff;
      }
      .plus-btn {
        margin-right: -18px;
        margin-top: -18px;
      }
    }
    .logout-btn {
      position: absolute;
      bottom: 40px;
      left: 40px;
      font-family: "Montserrat", sans-serif;
      font-size: 12px;
      min-width: 150px;
      span {
        margin-right: 5px;
      }
    }
    .site-btn {
      position: absolute;
      bottom: 90px;
      left: 40px;
      font-family: "Montserrat", sans-serif;
      font-size: 12px;
      min-width: 150px;
      span {
        margin-right: 5px;
      }
    }
  }
  .v-list .v-list-item--active,
  .v-list .v-list-item--active .v-icon {
    color: inherit;
    background: #00d95a;
  }

  .table-content {
    overflow-y: scroll;
  }

  td {
    white-space: nowrap;
    max-width: 100px;
    overflow: hidden;
    padding: 0 20px !important;
  }

  .v-app-bar {
    background: #fff !important;
  }

  .v-navigation-drawer__content {
    background: white !important;
  }
  .v-navigation-drawer__content .v-list-item__title {
    color: black !important;
  }

  @media only screen and (max-width: 600px) {
    th {
      padding-right: 20px;
    }
    td {
      max-width: 72vw !important;
    }
  }
  span.v-btn__content {
    color: black;
  }
  //rewritten classes

  .v-data-table__mobile-row__cell {
    padding-left: 15px;
  }

  .v-input--switch {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }

  .v-dialog {
    .v-input {
      margin: 0 !important;
      padding: 0 !important;
    }
    .col {
      margin: 0 !important;
      padding: 0 !important;
    }

    .v-label {
      font-size: 12px !important;
    }
  }

  .logout {
    margin-bottom: 0px;
  }

  .sublabel {
    padding-left: 25px;
    font-size: 14px !important;
  }
</style>
